import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../DesignSystem/button';
import RegistrationForm from './form';
import { NonAuthRoutes } from '../../../enums';

interface FormSectionProps {
  isRegisterDisabled: boolean;
  registrationLoading: boolean;
  unameError: string;
  emailError: string;
  scrollToTop: boolean;
  onFieldChange: (fieldName: string, value: string) => void;
  onEmailBlur: (_: any) => void;
  onRegister: () => void;
}

const FormSection: React.FC<FormSectionProps> = ({
  isRegisterDisabled, registrationLoading, unameError, emailError, scrollToTop, onFieldChange, onEmailBlur, onRegister,
}) => {
  const handleKeypress = useCallback((e) => {
    if (e.key === 'Enter' && !isRegisterDisabled) {
      onRegister();
    }
  }, [onRegister, isRegisterDisabled]);

  return (
    <div className="root">
      <h3>Private Node Request</h3>
      <div className="form-div">
        <RegistrationForm onKeypress={handleKeypress} onFieldChange={onFieldChange} onEmailBlur={onEmailBlur} unameError={unameError} emailError={emailError} scrollToTop={scrollToTop} />
      </div>
      <div className="submit-btn">
        <Button variant="primary" node="Request A Quote" disabled={isRegisterDisabled} onClick={onRegister} loading={registrationLoading} />
      </div>
    </div>
  );
};

export default FormSection;
